module.exports = __webpack_public_path__ + "static/img/msg_white.10050363.svg";